<template>
  <div class="content">
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{ $t('create_report_dialog_title') }}</md-dialog-title>

      <md-dialog-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>{{ $t('table_header_email') }}</label>
                <md-input v-model="email" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-60">
              <md-field>
                <label for="report_id">{{ $t('create_report_dialog_select_label') }}</label>
                <md-select v-model="report_id" name="report_id" id="report_id">
                  <md-option value="1">{{ $t('report_1') }}</md-option>
                  <md-option value="4">{{ $t('report_4') }}</md-option>
                  <md-option value="828017">{{ $t('report_828017') }}</md-option>
                  <md-option value="828020">{{ $t('report_828020') }}</md-option>
                  <md-option value="828027">{{ $t('report_828027') }}</md-option>
                  <md-option value="982368">{{ $t('report_982368') }}</md-option>
                  <md-option value="1629897">{{ $t('report_1629897') }}</md-option>
                  <md-option value="1629910">{{ $t('report_1629910') }}</md-option>
                  <md-option value="1508587">{{ $t('report_1508587') }}</md-option>
                  <md-option value="4554586">{{ $t('report_4554586') }}</md-option>
                  <md-option value="2232957">{{ $t('report_2232957') }}</md-option>
                  <md-option value="5514772">{{ $t('report_5514772') }}</md-option>
                  <md-option value="6520638">{{ $t('report_6520638') }}</md-option>
                  <md-option value="6758452">{{ $t('report_6758452') }}</md-option>
                  <md-option value="6758451">{{ $t('report_6758451') }}</md-option>
                  <md-option value="6843624">{{ $t('report_6843624') }}</md-option>
                  <md-option value="6843634">{{ $t('report_6843634') }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="submitReport();" data-testid="button-create">{{ $t('create_new') }}</md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                v-bind:title="$t('automated_reports_title')"
                v-bind:subTitle="$t('automated_reports_subtitle', { org: this.subTitle })"
                v-bind:data="this.reports"
                v-bind:dict="this.reportsDict"
        ></p-s-table>
      </div>
      <md-button class="md-primary" style="margin-left: auto; margin-right: 20px;" v-on:click="openCreateModal()" data-testid="button-openCreate">{{ $t('create_new') }}</md-button>
    </div>
  </div>
</template>

<script>
import PSTable from "../components/Tables/PSTable";
import api from '@/api/api';
import store from '@/store/index.js';

export default {
  name: "AutomaticReports",
  components: {
    PSTable
  },
  computed: {
    subTitle() {
      if (store.state.user.organizationName !== null) {
        return store.state.user.organizationName
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      reports: [],
      showDialog: false,
      email: '',
      report_id: '',
      reportsDict: [
        { key: 'mail', label: 'Email-Adresse', type: 'string'},
        { key: 'name', label: 'Bericht', type: 'string'}
      ]
    };
  },
  created () {
    this.pullData();
  },
  methods: {
    openCreateModal() {
      this.showDialog = true;
    },
    pullData() {
      store.commit("setLoading", true);

      api.getReports().then((result) => {
        this.reports = result.data;

        store.commit("setLoading", false);
      });
    },
    submitReport() {
      if (this.email !== '' && this.report_id !== '') {
        api.postReport(this.email, this.report_id).then(() => {
          this.showDialog = false;
          this.pullData();
        });
      }
    }
  }
};
</script>

<style scoped>

</style>
